import React, { FC } from 'react';
import { DraftStatus } from 'api/Responses/SetResponses';
import { DraftCollection } from 'components/DraftCollection';
import Page from 'components/Page';
import PageSpinner from 'components/PageSpinner/PageSpinner';
import useReview from 'hooks/useReview';

const ApprovePage: FC = () => {
  const { pendingSets, pendingDevices, loading } = useReview(DraftStatus.PENDING);
  return <Page>{loading ? <PageSpinner /> : <DraftCollection sets={pendingSets} devices={pendingDevices} />}</Page>;
};

export default ApprovePage;
